<script>
import { forEach } from 'lodash';

import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import soundPlayer from '@/components/soundPlayer';
import shareBtn from '@/components/shareBtn';
import movePageOnSwipe from '@/components/movePageOnSwipe';
import hoverDesign from '@/components/hoverDesign';

import album10 from '@/components/album10';
import album11 from '@/components/album11';
import album12 from '@/components/album12';
import album13 from '@/components/album13';
import album14 from '@/components/album14';
import album15 from '@/components/album15';

import setMetaUtil from '@/util/setMetaUtil';

export default {
  name: Constants.ROUTER.ALBUM,
  components: {
    commonFooter,
    commonNav,
    soundPlayer,
    shareBtn,
    movePageOnSwipe,
    hoverDesign,
    album10,
    album11,
    album12,
    album13,
    album14,
    album15,
  },
  data() {
    return {
      ready: false,
      cdList: [],
      albumId: 14,
      targetcdData: {},
      targetcdTextData: {},
      latestAlbum: 14,

      isTop: true,

      leftMoveto: { name: Constants.ROUTER.ALBUM15, },
      rightMoveto: { name: Constants.ROUTER.ALBUM15, },

      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
    };
  },
  created() {
    this.init();
  },
  watch:{
      $route (){ // クエリ変更時
        this.ready = false;
        setTimeout(()=> {
          this.init();
        }, 500);
      },
  },
  methods: {
    init() {
      this.getCdList(Number(this.$route.path.replace(/\/$/, '').split(Constants.ROUTER.ALBUM)[1]));
    
      setMetaUtil.setMeta(
        this,
        document,
        `${this.$i18n.messages.ja.message.discography.albums[`a${this.albumId}`].name
        } - ${this.$i18n.messages.ja.message.bandName}`,
        this.$i18n.messages.ja.message.discography.albums[`a${this.albumId}`].description,
        `/ogImage_album${this.albumId}`,
      );
      document.dispatchEvent(new Event('custom-render-trigger'));

      window.onscroll = () => { this.onscroll(); }
      window.onresize = () => { this.onscroll(); }
      this.onscroll();

      setTimeout(()=> {
        this.ready = true;
      }, 1);
    },
    getCdList(id) {
      this.albumId = id;
      this.cdList = [];
      forEach(this.$t('message.discography.albums'), (v) => {
        this.cdList.unshift(v);
      });

      this.targetcdData = Constants.ALBUM[`ALBUM${this.albumId}`];

      let targetIndex = 0;
      this.targetcdTextData = this.cdList.find((cd, i) => {
        if (cd.id === id) {
          targetIndex = i;
          return true;
        }
        return false;
      });
      if (!this.targetcdTextData) { // クエリの数字がおかしい場合
        this.$router.push({ name: Constants.ROUTER.NOTFOUND });
        return;
      }
      this.targetcdTextData.tracklist = [];
      forEach(this.targetcdTextData.tracks, (track) => {
        this.targetcdTextData.tracklist.push(track);
      });
      if (this.targetcdTextData.tracklist.length === 0 || this.targetcdData === undefined) { // クエリの数字がおかしい場合
        this.$router.push({ name: Constants.ROUTER.NOTFOUND });
        return;
      }
      // スワイプ用
      const leftIndex = targetIndex === this.cdList.length - 1 ? 0 : targetIndex + 1;
      const rightIndex = targetIndex === 0 ? this.cdList.length - 1 : targetIndex - 1;
      this.leftMoveto = { name: Constants.ROUTER[`ALBUM${this.cdList[leftIndex].id}`] };
      this.rightMoveto = { name: Constants.ROUTER[`ALBUM${this.cdList[rightIndex].id}`] };
    },
    moveToAlbumPage(id) {
      this.$router.push({ name: Constants.ROUTER[`ALBUM${id}`] });
    },
    moveToInDistribution() {
      this.$router.push({
          name: Constants.ROUTER[`DISTRIBUTION${this.albumId}`],
        });
    },
    onscroll() {
      this.isTop = window.pageYOffset === 0;
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  }
};
</script>

<template>
  <move-page-on-swipe
    :left-move-to="leftMoveto"
    :right-move-to="rightMoveto"
    class="view-album page"
    :class="[ready ? 'is-ready' : '', `album${albumId}`, $mq]"
  >
    <common-nav/>
    <div id="contents-main" :style="{'min-height': windowHeight + 'px'}">

      <div class="cd-container">
        <div class="common-info-container" v-if="ready">
          <div class="album-title"><span :title="targetcdTextData.name">{{targetcdTextData.name}}</span></div>
          <div class="album-advertising-slogan" v-html="targetcdTextData.advertisingSlogan"></div>
          <div class="common-info">
            <div class="jacket-container">
              <!--ジャケット-->
              <div class="jacket" :class="`is-album-jacket-${albumId}`"></div>

              <!--クロスフェード-->
              <div class="crossfade" v-if="targetcdData.HAS_CROSSFADE">
                <div class="title">{{$t('message.discography.crossfade')}}</div>
                <sound-player :folder="albumId" :file-name="'crossfade'" :is-long="true" :file-name-save="'crossfade'"
                  :youtube="targetcdData.CROSSFADE.YOUTUBE"
                  :niconico="targetcdData.CROSSFADE.NICONICO"
                />
              </div>

              <!--委託-->
              <div class="shop" v-if="targetcdData.SHOP.length > 0">
                <div class="title">{{$t('message.discography.sale')}}</div>
                <div class="banners">
                  <div v-for="shop in targetcdData.SHOP" :key="shop.shop">
                    <a
                      class="banner200x40"
                      :class="shop.shop"
                      :title="$t(`message.shop.${shop.shop}`)"
                      target="_blank"
                      :href="shop.url"
                    >
                      <hover-design/>
                    </a>
                  </div>  
                </div>
              </div>

              <!--配信-->
              <div class="distribution" v-if="targetcdData.DISTRIBUTION.length > 0">
                <div class="title">{{$t('message.distribution.streaming')}}</div>
                <div class="banners">
                  <div>
                    <a
                      class="banner200x40 distribution-banner"
                      :title="$t(`message.distribution.pageName`)"
                      @click="moveToInDistribution"
                    ></a>
                  </div>
                </div>
              </div>

              <!--DL販売-->
              <div class="dl" v-if="targetcdData.DL.length > 0">
                <div class="title">{{$t('message.discography.dlSale')}}</div>
                <div class="banners">
                  <div v-for="shop in targetcdData.DL" :key="shop.shop">
                    <a
                      class="banner200x40"
                      :class="shop.shop"
                      :title="$t(`message.shop.${shop.shop}`)"
                      target="_blank"
                      :href="shop.url"
                    >
                      <hover-design/>
                    </a>
                  </div>
                </div>
              </div>

              <!--スペシャル-->
              <div class="etc" v-if="targetcdData.SPECIAL.length > 0">
                <div v-for="contents in targetcdData.SPECIAL" :key="contents.banner">
                  <div class="title">{{$t(contents.title)}}</div>
                  <a
                    class="banner200x40"
                    :class="contents.banner"
                    :title="$t(`message.shop.${contents.banner}`)"
                    target="_blank"
                    :href="contents.url"
                  >
                    <hover-design/>
                  </a>
                </div>
              </div>


            </div>

            <div class="info-container">
              <div class="track-list">
                <div class="track" v-for="(track, index) in targetcdTextData.tracklist" :key="track.name">
                  <div class="title" :title="track.name">
                    <span class="text">{{index + 1}}. {{track.name}}</span>
                  </div>
                  <div class="audio-container" v-if="track.demo !== ''">
                    <sound-player :folder="albumId" :file-name="track.demo" :file-name-save="track.name"/>
                  </div>
                </div>
              </div>
              <div class="other-info">
                <div class="date">
                  <span>{{targetcdTextData.date}}</span>
                  <span class="event">{{targetcdTextData.event}}</span>
                </div>
                <div class="price" v-if="targetcdTextData.price !== ''">
                  {{$t('message.discography.price', {
                    price: targetcdTextData.price,
                  })}}
                </div>
                <div class="price" v-if="targetcdTextData.price === ''">
                  {{$t('message.discography.priceToBeDetermined')}}
                </div>
                <div class="price-dl" v-if="targetcdTextData.priceDl !== ''">
                  {{$t('message.discography.priceDl', {
                    price: targetcdTextData.priceDl,
                  })}}
                </div>
                <div class="price-shop" v-if="targetcdTextData.priceShop !== ''">
                  {{$t('message.discography.priceShop', {
                    price: targetcdTextData.priceShop,
                  })}}
                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="uncommon-info-container" v-if="ready">
          <album10 v-if="albumId == 10" />
          <album11 v-if="albumId == 11" />
          <album12 v-if="albumId == 12" />
          <album13 v-if="albumId == 13" />
          <album14 v-if="albumId == 14" />
          <album15 v-if="albumId == 15" />
        </div>
      </div>

      <div class="album-nav">
        <div class="album-cd-container" v-if="ready">
          <div class="cd-item"
            v-for="cdItem in cdList" :key="cdItem.id"
            :title="cdItem.name"
            :class="`is-album-jacket-${cdItem.id}`"
            @click="moveToAlbumPage(cdItem.id)"
          >
            <hover-design hover-design="checkered"/>
          </div>
        </div>
      </div>

    </div>
    <common-footer/>
    <share-btn :is-fixed="true"/>
  </move-page-on-swipe>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .page {
    position: relative;
    #contents-main {
      padding-top: $commonNavHeight;
      overflow: hidden;
      min-width: 0; // これが無いとellipsisがうまくいかない

      opacity: 0;
      transition: 0.5s ease-out;
      .cd-container {
        min-width: 0; // これが無いとellipsisがうまくいかない
        .common-info-container {
          display: flex;
          flex-direction: column;
          .album-title{
            text-align: center;
            border-top: 1px solid $textColorA50;
            border-bottom: 1px solid $textColorA50;
          }
          .album-advertising-slogan {
            text-align: center;
          }
          .common-info {
            flex: 1;
            .jacket-container {
              display: flex;
              flex-direction: column;
              .jacket {
                flex: 1;
                @include bgCenter;
                background-position: 50% 0;
                max-height: 405px;
              }
              .crossfade, .shop, .dl, .distribution, .etc {
                .title {
                  text-align: center;
                }
                margin: 0 0 5px 0;
                .banner200x40 {
                  margin: 3px auto;
                  position: relative;
                }
              }
              .distribution-banner {
                animation: distribution-anime 0.5s ease 0s infinite;
                &:hover {
                  animation: none;
                }
              }
              @keyframes distribution-anime {
                0%{transform: scale(1);}
                90%{transform: scale(1.2);}
                100%{transform: scale(1);}
              }
            }
            .info-container {
              flex: 1;
              min-width: 0; // これが無いとellipsisがうまくいかない
              .track-list {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                overflow-y: auto;
                padding-bottom: 20px;
                .track {
                  line-height: 30px;
                  .title {
                    flex: 1;
                    min-width: 0; // これが無いとellipsisがうまくいかない
                    span {
                      max-width: 100%;
                      display: inline-block;
                    }
                  }
                  .audio-container {
                  }
                }
              }
              .other-info {
                height: 180px;
                padding-left: 25px;
                display: flex;
                flex-direction: column;
                justify-content:space-around;
                background: $textColorA50;
                border-radius: 20px;
                text-align: left;
                .date, .price, .price-dl, .price-shop {
                }
                .date {
                  .event {
                    margin-left: 10px;
                  }
                }
              }
            }
          }
          
        }
        .uncommon-info-container {
          position: relative;
        }
      }

      .album-nav {
        .album-cd-container {
          width: 100%;
          height: 100%;
          .cd-item {
            position: relative;
            cursor: pointer;
            @include bgCenter;
            transition: 0.1s ease-out;
            filter: grayscale(0%);
            &:hover {
              z-index: $zIndexAlbumListHover;
              transform: scale(1.3);
              filter: grayscale(100%);
            }
          }
        }
      }
      
    }

    &.is-ready {
      #contents-main {
        opacity: 1;
      }
    }
    // responsible -----------------------------------------------
    &.viewLg {
      #contents-main {
        display: flex;
        flex-direction: row;
        .cd-container {
          flex: 1;
          .common-info-container {
            min-height: 900px;
            .album-title {
              padding: 0 0 0 140px;
              height: 40px;
              line-height: 40px;
              font-size: 1.5em;
              span {
                @include ellipsis;
              }
            }
            .album-advertising-slogan {
              padding: 0 0 0 140px;
              min-height: 75px;
              font-size: 1em;
              line-height:  25px;
            }
            .common-info {
              display: flex;
              .jacket-container {
                width: 400px;
                margin-left: 20px;
                .jacket {
                  min-height: 400px;
                }
                .crossfade, .shop, .dl, .distribution, .etc {
                  .banners {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    .banner200x40 {
                      height: 35px;
                      width: 175px;
                      margin: 3px;
                    }
                  }
                }
              }
              .info-container {
                display: flex;
                flex-direction: column;
                padding: 30px 20px 0 20px;
                .track-list {
                  .track {
                    display: flex;
                    height: 30px;
                    text-align: left;
                    .title {
                      span {
                        @include ellipsis;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .album-nav {
          width: 100px;
          height: 100%;
          .album-cd-container {
            position: fixed;
            top: $commonNavHeight;
            right: 0;
            width: 100px;
            .cd-item {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
    &.viewMd {
      #contents-main {
        .cd-container {
          .common-info-container {
            .album-title {
              min-height: 40px;
              line-height: 40px;
              font-size: 1.2em;
            }
            .album-advertising-slogan {
              min-height: 75px;
              font-size: 0.9em;
              line-height:  25px;
            }
            .common-info {
              .jacket-container {
                display: block;
                width: 100%;
                min-height: 400px;
                .jacket {
                  height: 400px;
                }
              }
              .info-container {
                padding: 30px 10px;
                .track-list {
                  width: 90%;
                  margin: auto;
                  .track {
                    min-height: 30px;
                    margin-bottom: 20px;
                    .audio-container {
                      max-width: 400px;
                    }
                  }
                }
              }
            }
          }
          .uncommon-info-container {
            width: 90%;
            margin: auto;
          }
        }
        
        .album-nav {
          width: 95%;
          height: 100px;
          margin: auto;
          .album-cd-container{
            display: flex;
            .cd-item {
              height: 100%;
              width: 20%; // TODO cdの枚数で変える
            }
          }
        }
      }
    }
    &.viewSm {
      #contents-main {
        .cd-container {
          .common-info-container {
            .album-title {
              min-height: 30px;
              line-height: 30px;
              font-size: 1em;
            }
            .album-advertising-slogan {
              min-height: 60px;
              font-size: 0.7em;
              line-height:  20px;
            }
            .common-info {
              .jacket-container {
                display: block;
                width: 90%;
                margin: auto;
                min-height: 300px;
                .jacket {
                  height: 300px;
                  background-position: 50% 50%;
                }
              }
              .info-container {
                padding: 30px 0;
                .track-list {
                  width: 90%;
                  margin: auto;
                  .track {
                    min-height: 30px;
                    margin-bottom: 20px;
                  }
                }
              }
            }
          }
          .uncommon-info-container {
            width: 90%;
            margin: auto;
          }
        }

        .album-nav {
          width: 100%;
          height: 100px;
          .album-cd-container{
            width: 100%;
            display: flex;
            flex-direction: row;
            .cd-item {
              height: 100%;
              width: 20%; // TODO cdの枚数で変える
            }
          }
        }
      }
    }

    .banner200x40 {
      margin: 0px auto;
      transition: 0.1s ease-out;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
</style>

